import dayjs from "dayjs";

import { Box, Stack } from "@mui/material";
import { Custom, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { forwardRef, useImperativeHandle } from "react";
import { createStep } from "utils/helpers";

const StepSchedule = forwardRef((_, ref) => {
  const { updateData, data } = useWorkflow<Workflow.Utils.PotluckType>(); // Include updateData and potluck
  const { theme } = useTheme();
  const { t } = useApp();

  useImperativeHandle(ref, () => ({
    validate: () => {
      let isValid = true;

      if (data.potluck.start_time && data.potluck.end_time) {
        isValid =
          dayjs(data.potluck.start_time, "h:mm A").toDate() <
          dayjs(data.potluck.end_time, "h:mm A").toDate();
      } else if (!data.potluck.start_time && data.potluck.end_time) {
        isValid = false;
      }

      return {
        isValid,
        message: isValid
          ? ""
          : t.component.workflow.potluck.validation.time_range,
      };
    },
  }));

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.potluck.start_potluck}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
          {t.component.workflow.potluck.schedule_hosting}
        </Custom.Typography>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.md}>
          <Custom.DatePicker
            required
            label={t.label.select_date}
            value={data.potluck.date}
            onChange={(date) => updateData("potluck.date", date)}
          />
          <Box>
            <Stack direction="row" gap={theme.spacing.sm}>
              <Custom.TimePicker
                label={t.label.start_time}
                value={data.potluck.start_time}
                onChange={(time) => updateData("potluck.start_time", time)}
              />{" "}
              <Custom.TimePicker
                label={t.label.end_time}
                value={data.potluck.end_time}
                onChange={(time) => updateData("potluck.end_time", time)}
              />
            </Stack>
          </Box>
        </Stack>
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.PotluckType>(StepSchedule);
